<template>
  <div class="page-s2 with-navbar-s2" id="explore">
    <rebuild-nav-bar></rebuild-nav-bar>
    <div class="container">
      <img src="~@static/fundingnew_/detail/jolin/1/img-1.jpg" alt="" width="100%">
      <img src="~@static/fundingnew_/detail/jolin/1/img-2.jpg" alt="" width="100%">
      <div class="v-box">
        <img src="~@static/fundingnew_/detail/jolin/1/img-3.jpg" alt="" width="100%">
        <div class="video-s2">
          <video ref="video1" src="~@static/fundingnew_/detail/jolin/1/video.mp4" controls width="100%" preload="auto" x-webkit-airplay="true" x5-playsinline="true" webkit-playsinline="true" playsinline="true"></video>
          <div class="placeholder_img" @click="play" v-show="isStop">
            <img src="~@static/fundingnew_/detail/jolin/1/v2_poster.jpg" alt="">
          </div>
        </div>
        <div class="btn-area text-center">
          <div class="btn-creation" @click="bindToCreation">
            <step-btn type="next" value="#造一个夜计划#"></step-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RebuildNavBar from '@components/RebuildNavBar'
import StepBtn from '../components/StepBtn'
import { verify } from '@/utils'
import { behavior } from '@/utils/behavior'
export default {
  data() {
    return {
      isStop: true,
      isBili: false,
    }
  },
  components: {
    RebuildNavBar,
    StepBtn,
  },
  created() {
    let { channel } = this.$route.query
    if (channel === 'bilibili') {
      this.isBili = true
    }
  },
  mounted() {
    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      this.WXConfig.wxShowMenu(location.href, shareInfo)
    }
  },
  methods: {
    play() {
      this.isStop = false
      this.$refs.video1.play()
      _jcq.push(['_track', 'yjhbc_jolinvideo2click'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc7' })
    },
    bindToCreation() {
      if (this.isBili) {
        this.$router.push('/fundingnew/creation?creation_from=bili')
      } else {
        this.$router.push('/fundingnew/creation')
      }
      _jcq.push(['_track', 'yjhbccreate'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc5' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/v2-common.scss';
.v-box {
  position: relative;
}
.video-s2 {
  position: absolute;
  left: 0;
  top: pxtow(36);
  height: pxtow(422);
  width: pxtow(750);
  .placeholder_img {
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.btn-area {
  position: absolute;
  top: 66vw;
  width: 100%;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/project/jolin.vue